<template>
  <v-theme-provider light>
    <div class="section-request-demo" style="padding-top: 100px; padding-bottom: 60px;">
      <v-container class="py-12">
        <v-row class="display-2 font-weight-medium text-center">
          <v-col>
            <p class="grey--text text--darken-3">
              <!-- <v-icon class="blink" color="primary">mdi-color-helper</v-icon>See how Patrowl<span class="animated orange--text text--darken-2 font-weight-bold"></span> <br/>is a good fit for your organization -->
              <v-icon class="blink" color="primary">mdi-color-helper</v-icon>See how Patrowl<span class="orange--text text--darken-2 font-weight-bold">Hears</span> <br/>is a good fit for your organization
            </p>
          </v-col>
        </v-row>
        <v-row >
          <v-col align="center">
            <v-btn outlined class="ma-2" to="/get-started">Request a Demo today</v-btn>
            <v-btn raised elevation="4" color="primary" to="/get-started">Free Trial<v-icon right>mdi-arrow-right-bold</v-icon></v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "SecRequestDemo"
};
</script>
